export const RoutePaths = {
    HOME: '/',
    STEPS: '/#steps',
    NEWS: '/news',
    CURRENT_NEWS: '/news/:id',
    RULES: '/rules',
    OB_SOVET: '/ob-sovet',
    // SUPPORT: 'https://лк.время-героев.рф/v/faq',
    SUPPORT: '/faq',
    FEEDBACK: '/faq/feedback',
    POLICY: '/policy',
    LOGIN: 'https://лк.время-героев.рф/v/login',
    CONTACTS: '/contacts',
    LK: 'https://project.rsv.ru/geroi_yaroslavii',
    TEST: '/test',
}